import { useCallback, useState } from 'react';
import { twJoin } from 'tailwind-merge';

import FlagFR from './images/fr.svg';
import FlagFR_1x1 from './images/fr_1x1.svg';
import FlagGB from './images/gb.svg';
import FlagGB_1x1 from './images/gb_1x1.svg';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import { locale, setLocale } from '../../services/translation/translation';

export const LocaleSwitch = () => {
  const [isVisible, setIsVisible] = useState(false);

  const ref = useOnClickOutside(
    useCallback(() => {
      setIsVisible(false);
    }, []),
  );

  return (
    <div className="flex flex-col items-end relative">
      <button
        className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
        type="button"
        onClick={() => setIsVisible(v => !v)}
      >
        {locale === 'fr' ? (
          <img className="w-6 h-6 rounded-full" alt="Drapeau Français" src={FlagFR_1x1} />
        ) : (
          <img className="w-6 h-6 rounded-full" alt="English flag" src={FlagGB_1x1} />
        )}
      </button>

      <div
        ref={ref}
        className={twJoin(
          'absolute z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600 top-8 right-0',
          isVisible ? 'block' : 'hidden',
        )}
      >
        <ul className="py-2 text-sm cursor-pointer text-gray-700 dark:text-gray-200">
          <li>
            <button
              type="button"
              className="w-full flex items-center px-4 py-2 gap-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
              onClick={() => setLocale('fr')}
            >
              <img className="w-4" alt="Drapeau Français" src={FlagFR} />
              <span>Francais</span>
            </button>
          </li>
          <li>
            <button
              type="button"
              className="w-full flex items-center px-4 py-2 gap-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
              onClick={() => setLocale('en')}
            >
              <img className="w-4" alt="English flag" src={FlagGB} />
              <span>English</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};
